import React from "react"
import { StaticQuery, graphql } from "gatsby"
import WOW from "react-wow"

import * as S from "./styled"

const Footer = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          brandImage: file(relativePath: { eq: "brand.png" }) {
            childImageSharp {
              fluid(maxWidth: 150) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      `}
      render={data => (
        <S.FooterWrapper>
          <WOW animation="fadeInUp">
            <S.FooterBrand
              fluid={data.brandImage.childImageSharp.fluid}
            ></S.FooterBrand>
            <S.FooterCopy>
              {`© Evolve Studio  2017 • ${new Date().getFullYear()}`}
              <br /> {`Todos os direitos reservados.`}
            </S.FooterCopy>
          </WOW>
        </S.FooterWrapper>
      )}
    />
  )
}

export default Footer
